import { Login } from '@/components/login';
import { Colors } from '../../../public/GlobalTokens';

interface LoginPageProps {
  signIn: () => void;
}

const LoginPage = ({ signIn }: LoginPageProps) => {
  const onSingleSignOn = (event: React.MouseEvent) => {
    event.preventDefault();
    signIn();
  };

  return (
    <section
      className="w-full h-full flex flex-col items-center justify-center"
      style={{ backgroundColor: Colors.colorType.inverse.darkest }}
    >
      <Login singleSignOnClick={onSingleSignOn} singleSignOn />
    </section>
  );
};

export default LoginPage;
